import ValidateStep from "./validateStep"

/**
 * ValidateStep1 class
 * @extends ValidateStep
 * @classdesc This class is used to validate the first step of the form - mainly for user data
 */
export default class ValidateStep1 extends ValidateStep {
    constructor(cPM, user, btn) {
        super(cPM, user, btn)
        this.cPM = cPM
        this.user = user
        ;(this.customberNumber = document.querySelector("#customer-number #newID")),
            (this.firstName = document.querySelector("#powermail_field_vorname")),
            (this.lastName = document.querySelector("#powermail_field_nachname")),
            (this.email = document.querySelector("#powermail_field_emailadresse")),
            (this.phone = document.querySelector("#powermail_field_telefonnummer")),
            (this.street = document.querySelector("#powermail_field_strasseundhausnummer")),
            (this.zip = document.querySelector("#powermail_field_plz")),
            (this.city = document.querySelector("#powermail_field_ort")),
            (this.company = document.querySelector("#powermail_field_firma"))
        this.dataPrivacy = document.querySelector("#powermail_field_datenschutz_01_1")
        this.continueButton = btn
        this.continue = document.querySelector(".powermail_form .pull-right[data-powermail-morestep-show='1']")
        this.errorField = document.querySelector(".powermail_fieldwrap_errorlist-step1")
        this.setEventsForAllInputs()
        this.initButton()
    }

    /**
     * validates the first step of the form
     * @returns {boolean} validation result
     */
    validate() {
        if (
            this.checkCustomerNumber() == true &&
            this.checkFirstName() == true &&
            this.checkLastName() == true &&
            this.checkEmail() == true &&
            this.checkPhone() == true &&
            this.checkStreet() == true &&
            this.checkZip() == true &&
            this.checkCity() == true &&
            // && this.checkCompany() == true // optional, can be empty => so no validation
            this.checkDataPrivacy() == true
        ) {
            this.cPM.step1Valid = true
            if (this.continueButton && this.continue) {
                this.continue.removeAttribute("disabled")
            }
            this.valid = true
            if(document.querySelector("#powermail_field_handynummer").value.length > 0) {
                let hnr = document.querySelector("#powermail_field_handynummer").value;
                this.user.handynummer = hnr;
            }
            if(document.querySelector("#powermail_field_betriebsnummer").value.length > 0) {
                this.user.betriebsnummer = document.querySelector("#powermail_field_betriebsnummer").value
            }
        } else {
            // console.warn("validateStep1: not all inputs are valid");
            this.cPM.step1Valid = false
            if (this.continueButton && this.continue) {
                this.continue.setAttribute("disabled", "disabled")
            }
            this.valid = false
        }
        return this.valid
    }

    /**
     * validates the customer number
     * @returns {boolean} validation result
     */
    checkCustomerNumber() {
        let elem = this.customberNumber
        elem.valid = this.checkIfValue(elem)
        if (!elem.valid) {
            console.error("validateStep1: customer number is not set!")
            return false
        }
        return elem.valid
    }

    /**
     * checks if the first name input is empty
     * @returns {boolean} validation result
     */
    checkFirstName() {
        let elem = this.firstName
        elem.valid = this.checkIfValue(elem)
        // if(!elem.valid) {
        //     this.showSpecificError(elem, "Bitte geben Sie Ihren Vornamen ein.");
        // }
        // if (elem.value.length < 2) {
        //     this.showSpecificError(elem, "Ihr Vorname muss mindestens 2 Zeichen lang sein.");
        //     elem.valid = false;
        // }

        return elem.valid
    }

    /**
     * checks if the last name input is empty
     * @returns {boolean} validation result
     */
    checkLastName() {
        let elem = this.lastName
        elem.valid = this.checkIfValue(elem)
        // if(!elem.valid) {
        //     this.showSpecificError(elem, "Bitte geben Sie Ihren Nachnamen ein.");
        // } else {
        //     this.removeError(elem);
        // }
        // if (elem.value.length < 2) {
        //     this.showSpecificError(elem, "Ihr Nachname muss mindestens 2 Zeichen lang sein.");
        //     elem.valid = false;
        // } else {
        //     this.removeError(elem);
        // }

        return elem.valid
    }

    /**
     * checks if the email input is empty
     * @returns {boolean} validation result
     */
    checkEmail() {
        let elem = this.email
        elem.valid = this.checkIfValue(elem)
        // if(!elem.valid) {
        //     this.showSpecificError(elem, "Bitte geben Sie Ihre E-Mail-Adresse ein.");
        // } else {
        //     this.removeError(elem);
        // }
        // // Simple email validation regex
        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // if (!emailRegex.test(elem.value)) {
        //     this.showSpecificError(elem, "Bitte geben Sie eine gültige E-Mail-Adresse ein.");
        //     elem.valid = false;
        // } else {
        //     this.removeError(elem);
        // }

        return elem.valid
    }

    /**
     * checks if the phone input is empty
     * @returns {boolean} validation result
     */
    checkPhone() {
        let elem = this.phone
        elem.valid = this.checkIfValue(elem)
        // if(!elem.valid) {
        //     this.showSpecificError(elem, "Bitte geben Sie Ihre Telefonnummer ein.");
        // } else {
        //     this.removeError(elem);
        // }
        // Simple phone validation regex (basic check)
        // const phoneRegex = /^\+?[0-9\s\-()]+$/;
        // if (!phoneRegex.test(elem.value)) {
        //     this.showSpecificError(elem, "Bitte geben Sie eine gültige Telefonnummer ein.");
        //     elem.valid = false;
        // } else {
        //     this.removeError(elem);
        // }
        return elem.valid
    }

    /**
     * checks if the street input is empty
     * @returns {boolean} validation result
     */
    checkStreet() {
        let elem = this.street
        elem.valid = this.checkIfValue(elem)
        // if(!elem.valid) {
        //     this.showSpecificError(elem, "Bitte geben Sie Ihre Straße und Hausnummer ein.");
        // } else {
        //     this.removeError(elem);
        // }

        return elem.valid
    }

    /**
     * checks if the zip input is empty
     * @returns {boolean} validation result
     */
    checkZip() {
        let elem = this.zip
        elem.valid = this.checkIfValue(elem)
        if (!elem.valid) {
            this.showSpecificError(elem, "Bitte geben Sie Ihre Postleitzahl ein.")
        } else {
            this.removeError(elem)
        }
        // Simple zip code validation regex (basic check)
        const zipRegex = /^\d{5}$/ // Adjust regex based on your country's zip code format
        if (!zipRegex.test(elem.value)) {
            this.showSpecificError(elem, "Bitte geben Sie eine gültige Postleitzahl ein.")
            elem.valid = false
        } else {
            this.removeError(elem)
        }

        return elem.valid
    }

    /**
     * checks if the city input is empty
     * @returns {boolean} validation result
     */
    checkCity() {
        let elem = this.city
        elem.valid = this.checkIfValue(elem)
        // if (!elem.valid) {
        //     this.showSpecificError(elem, "Bitte geben Sie Ihre Stadt ein.");
        // } else {
        //     this.removeError(elem);
        // }

        return elem.valid
    }

    /**
     * checks if the company input is empty
     * @returns {boolean} validation result
     */
    checkCompany() {
        let elem = this.company
        elem.valid = this.checkIfValue(elem)
        // if(!elem.valid) {
        //     this.showSpecificError(elem, "Bitte geben Sie Ihren Firmennamen ein.");
        // } else {
        //     this.removeError(elem);
        // }

        return elem.valid
    }

    /**
     * checks if the data privacy checkbox is checked
     * @returns {boolean} validation result
     */
    checkDataPrivacy() {
        let elem = this.dataPrivacy
        elem.valid = this.checkIfChecked(elem)
        // if(!elem.valid) {
        //     this.showSpecificError(elem, "Bitte akzeptieren Sie die Datenschutzerklärung.");
        // } else {
        //     this.removeError(elem);
        // }
        return elem.valid
    }

    /**
     * sets the events for all inputs
     * @returns {void}
     */
    setEventsForAllInputs() {
        try {
            this.firstName.addEventListener("change", () => {
                this.checkFirstName()
            })
            this.lastName.addEventListener("change", () => {
                this.checkLastName()
            })
            this.email.addEventListener("change", () => {
                this.checkEmail()
            })
            this.phone.addEventListener("change", () => {
                this.checkPhone()
            })
            this.street.addEventListener("change", () => {
                this.checkStreet()
            })
            this.zip.addEventListener("change", () => {
                this.checkZip()
            })
            this.city.addEventListener("change", () => {
                this.checkCity()
            })
            this.company.addEventListener("change", () => {
                this.checkCompany()
            })
            this.dataPrivacy.addEventListener("change", () => {
                this.checkDataPrivacy()
            })
        } catch (error) {
            console.error("Error setting events for inputs:", error)
        }
    }

    /**
     * sets the event for the continue button
     */
    initButton() {
        if (!this.continueButton && !this.continue) {
            console.warn("validateStep1: no continue button found, skipping button initialization")
            return
        }

        let validateClickElems = [this.continue]

        let validateChangeElems = [this.continueButton, this.phone, this.street, this.zip, this.city]

        validateClickElems.forEach((element) => {
            if (!element) {
                console.warn("validateStep1: no continue button found, skipping button initialization")
                return
            }

            element.addEventListener("click", (e) => {
                this.triggervalidate(element, true)
            })
        })

        validateChangeElems.forEach((element) => {
            if (!element) {
                console.warn("validateStep1: no change element found, skipping change event initialization")
                return
            }

            element.addEventListener("change", (e) => {
                this.triggervalidate(element, false)
            })
        })
    }

    triggervalidate(element, totop) {
        this.hideError()
        if (!this.validate()) {
            this.cPM.firstStep()
            this.cPM.scrollToElement(".powermail_field_error", true)
            this.showError()
        } else if (totop) {
            this.cPM.scrollToElement(".powermail_form", true)
        }
    }

    hideError() {
        let error = this.errorField
        if (error) {
            error.classList.remove("vis")
        }
    }

    showError() {
        let error = this.errorField
        if (error) {
            error.classList.add("vis")
        }

        /* shows error messages for specific items - here: dataprivacy */
        let errors = document.querySelectorAll(".powermail_field_error")
        errors.forEach((error) => {
            let message = error.dataset.powermailRequiredMessage
            let container = document.querySelector(error.dataset.powermailErrorsContainer)

            if (!container) {
                console.warn("validateStep1: no container found for error messages, skipping")
                this.showSpecificError(error, message)
                console.warn("validateStep1: error message for " + error.id + " is: " + message)
                return
            }

            container.innerHTML = message
            container.classList.add("powermail-errors-list")
            container.classList.add("filled-cst")
            container.classList.add("filled")

            error.addEventListener("change", () => {
                if (container.classList.contains("hidden")) {
                    container.classList.remove("hidden")
                }
                // If the error is a checkbox and it is checked, hide the error container
                if (error.classList.contains("powermail_checkbox") && error.checked) {
                    container.classList.add("hidden")
                } else if (error.classList.contains("powermail_field_error")) {
                    container.classList.remove("hidden")
                } else {
                    console.warn("validateStep1: error is not a checkbox or field error, skipping")
                }
            })
        })
    }

    showSpecificError(elem, optional_text) {
        if (!elem) return
        let text = optional_text || "Dieses Feld muss ausgefüllt werden!"
        // console.log("ERROR AT VALIDATION: showSpecificError: " + text , elem);
        try {
            let existingError = elem.parentElement.querySelector(".custom-error-message")
            let existingList = elem.parentElement.querySelector(".powermail-errors-list.filled")

            if (existingList) {
                return // If there is already a list of errors, do not create a new one
            }

            if (existingError) {
                existingError.textContent = text
                return
            }
        } catch (error) {
            // console.debug("showSpecificError: Error finding existing error element", error)
        }

        const errorElement = document.createElement("div")
        errorElement.classList.add("custom-error-message")
        errorElement.classList.add("powermail_field_error")
        errorElement.textContent = text

        try {
            elem.after(errorElement)
        } catch (error) {
            // console.debug("ERROR: showSpecificError: Error inserting error element after input", error);
        }
    }

    removeError(elem) {
        let existingError
        if (!elem) return

        try {
            existingError = elem.parentElement.querySelector(".custom-error-message")
            if (existingError) {
                existingError.remove()
                // console.log("removeError: removing error for element", elem);
            }
        } catch (error) {
            // console.debug("removeError: Error finding existing error element", error);
        }
    }
}
